var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReceiptRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36.003,
    viewBox: "0 0 36 36.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "invoice_1_",
    "data-name": "invoice (1)",
    d: "M30.455,1H7.545a1.636,1.636,0,0,0-1.064.409,6.545,6.545,0,0,1,4.336,5.482,2.864,2.864,0,0,1,0,.655V35.364a1.634,1.634,0,0,0,2.7,1.244l4.664-3.993,4.664,3.993a1.636,1.636,0,0,0,2.127,0l4.664-3.993L34.3,36.607A1.636,1.636,0,0,0,35.364,37a1.734,1.734,0,0,0,.687-.147A1.636,1.636,0,0,0,37,35.364V7.545A6.545,6.545,0,0,0,30.455,1ZM28.818,23.909H19a1.636,1.636,0,1,1,0-3.273h9.818a1.636,1.636,0,1,1,0,3.273Zm0-6.545H19a1.636,1.636,0,1,1,0-3.273h9.818a1.636,1.636,0,1,1,0,3.273Zm0-6.545H19a1.636,1.636,0,1,1,0-3.273h9.818a1.636,1.636,0,1,1,0,3.273ZM7.545,7.545V20.636H2.636A1.636,1.636,0,0,1,1,19V6.891a3.289,3.289,0,0,1,6.545.655Z",
    transform: "translate(-1 -1)",
    fill: "#9f393a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceiptRed);
export default __webpack_public_path__ + "static/media/icon-receipt-red.0b3c0109cf3dd24467f055ca2cd1db27.svg";
export { ForwardRef as ReactComponent };